<template>
  <div id="app">
    <transition name="van-slide-right">
      <router-view />
    </transition>
  </div>
</template>
<script>
export default {
  name: 'AppView',
  mounted(){
   // this.$router.push({ name: 'maintain' })
  }
}
</script>
<style lang="scss">

</style>
